var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscountCorner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.746.002a.89.89 0 0 0-.601.32L0 10l.09-.103H10v-8.33L9.632.668C9.484.288 9.163 0 8.803 0c-.019 0-.038 0-.057.002"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.64 11.03C-.455 12.3.067 12.93.641 12.993L10 13 9.904 0C8.301 1.69.64 11.03.64 11.03"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01 0C2.71 0 .03 3.079.015 6.891.006 9.531 0 12.715 0 16.193v1.4c.002 16.522.09 38.684.09 41.291 0 .617.433 1.116.967 1.116h.849c-.01-.003-.1-.004-.11-.007-.993-.233-.545-1.296-.145-1.777L9.66 48.93l.008.003 32.681-37.768 7.86-9.493a.855.855 0 0 1 .581-.314c.37-.032.705.26.855.653l.355.882v-.369C52 1.136 51.03.01 49.829.01 46.7.007 18.509.002 6.009 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountCorner);
export default __webpack_public_path__ + "static/media/discount-corner.745656c55079e2db37bbfc464af30f66.svg";
export { ForwardRef as ReactComponent };